import Cookies from '@mentimeter/cookies';
import { USER_LOCALE_STORAGE_KEY } from '../constants';
import type { Locale } from '../types';
import { getValidLocale } from '../getValidLocale';

/**
 * Get the locale from the cookie on the client side.
 * @param allowedLocales - An array of allowed locales.
 * @returns - The locale from the cookie or the default locale.
 *
 * If no allowed locales are provided, it will allow `en`, `de-DE`, `pt-BR`, `es-ES`.
 */

export const getLocaleFromCookieOnClient = <T = Locale>(opts?: {
  allowedLocales?: T[];
}): T => {
  const localeFromCookie = Cookies.get(USER_LOCALE_STORAGE_KEY);

  const locale: T = getValidLocale({
    locale: localeFromCookie,
    allowedLocales: opts?.allowedLocales,
  });
  return locale;
};
